import { Component, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "roblex-modal-body",
    templateUrl: "./modal-body.component.html",
    styleUrls: ["./modal-body.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class ModalBodyComponent {
    constructor() {}
}
